import './App.css';
import FormStepper from './Components/FormStepper'

function App() {
  return (
    <div >
      <FormStepper />
    </div>
  );
}

export default App;
